import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCheck } from "@fortawesome/free-solid-svg-icons"

export const Check = (props) => {
  return <FontAwesomeIcon faIcon={faCheck} {...props} />
}
